import React, {Fragment} from "react";
import SVG from "react-inlinesvg";
import shareReportSVG from "../../../../../assets/svg/ils/ils-share-report.svg";
import SweetAlertBase from "../../../../ui/sweetalert/SweetAlertBase";

class SA_ShareDone extends SweetAlertBase {

    html =  (
        <Fragment>
            <SVG src={shareReportSVG}/>
            <h2>Share Evaluation Reports</h2>
            <p>Evaluation report has been sahred with 3 peoples successfully</p>
        </Fragment>
    );

    type() {
        return 'sm';
    }

    className() {
        return "share-done";
    }

    confirmButtonClasses() {
        return "btn btn-primary btn-md btn-block";
    }
};

export default SA_ShareDone;